import FormHelpers from '../util/form';
import { newModalFromString } from '../components/modal';

var url;

module.exports = {
    removePayment: function () {
        $('.remove-payment').on('click', function (e) {
            e.preventDefault();
            url = $(this).data('url') + '?UUID=' + $(this).data('id');
            $('.payment-to-remove').empty().append($(this).data('card'));
            $('body').trigger('account:removingCard', { 'action': 'delete_credit_card' });
            const htmlContent = $($(this).data('target')).html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false);
            modal.open();
            $(modal.modalBox)
                .find('.close')
                .on('click', function (e) {
                    e.preventDefault();
                    modal.close();
                });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $('.delete-confirmation-btn').click(function (f) {
                f.preventDefault();
                $('.remove-payment').trigger('payment:remove', f);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        // TODO handle rehydration instead of redirect;
                        $('body').trigger('account:removingCard', { 'action': 'remove_credit_card_confirmation' });
                        window.location.reload();
                        modal.close();
                        $('#uuid-' + data.UUID).remove();
                        if (data.message) {
                            var toInsert = '<div><h3>' +
                            data.message +
                            '</h3><div>';
                            $('.paymentInstruments').after(toInsert);
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        $.spinner().stop();
                    }
                });
            });
        });
    },

    submitPayment: function () {
        $('form.payment-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            url = $form.attr('action');
            $.spinner().start();
            $('form.payment-form').trigger('payment:submit', e);
            let isAmexSelected = $('#CREDIT_CARD_AMEX:checked').length > 0;
            var formData = FormHelpers.serializeData($form, isAmexSelected);
            if ($('.saved-payment-security-code').length) {
                var cvvCode = $('.saved-payment-security-code').val();
                var regex = new RegExp('^[0-9]{3,4}$');
                if (!regex.test(cvvCode)) {
                    $('.saved-payment-security-code').addClass('is-invalid');
                    $('.security-code-input .invalid-feedback').show();
                    $.spinner().stop();
                    return;
                }
            }
            $('body').trigger('account:savingCard');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init($form, data);
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    if (err.redirectUrl) {
                        window.location.href = err.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    handleMobileTooltip: function () {
        if (($('.security-code-input').length || $('#securityCode').length) && !Foundation.MediaQuery.atLeast('medium')) {
            $('body').on('touchstart', '.info-icon .tooltip-info-icon', function (e) {
                var $target = $(e.currentTarget).closest('.info-icon').find('.tooltip');
                $target.css({
                    'visibility':'visible',
                    'opacity': '1'
                });
                $('body').one('touchstart', function (e) {
                    if (!$(e.currentTarget).closest('.info-icon').length) {
                        $target.css({
                            'visibility':'hidden',
                            'opacity': '0'
                        });
                    }                
                });
            });
        }
    },

    handleCreditCardNumber: function () {
        if ($('#cardNumber').length && $('#cardType').length) {
            FormHelpers.handleCreditCardNumber('#cardNumber', '#cardType');
        }
    },

    defaultPayment: function () {
        $('.make-default-listing').on('click', function (e) {
            var redirectUrl = $(this).data('url') + '?UUID=' + $(this).data('id');
            if (redirectUrl) {
                location.href = redirectUrl;
            }
        });
    }
};
